export default __webpack_public_path__ + "static/media/carwfd.a363b53f.jpg";